export const BASE_URL = '/auth'

export default {
  LOGIN: `${BASE_URL}/login`,
  TWOFACTOR: `${BASE_URL}/twofactor`,
  FORGOT_PASSWORD: `${BASE_URL}/forgot-password`,
  CHANGE_PASSWORD: `${BASE_URL}/change-password`,
  USER_CHANGE_PASSWORD: `${BASE_URL}/user-change-password`,
}
